"use client";

import { createContext } from "react";

const SearchModalContext = createContext({
  isSearchModalOpen: false,
  setIsSearchModalOpen: () => {},
});

export default SearchModalContext;
